<template>
  <div class="wrapper-blog">
    <SubheaderBlog />
    <main class="pad-3 bg-blog">
      <div class="bb-container">
        <h1 class="header-1">{{ $t('blog.heroTitle', lang) }}</h1>
        <h2 class="header-2">{{ $t('blog.featuredHeading', lang) }}</h2>
        <div class="g-post">
          <div class="g-post__items">
            <BlogPostThumb
              :post="featuredPost"
              class="thumb-post--land thumb-post--hero"
              showExcerpt
            />
            <BlogPostThumb
              v-for="featured2Post in featured2Posts"
              :key="featured2Post.id"
              :post="featured2Post"
              class="thumb-post--land"
            />
          </div>
        </div>
        <h2 class="header-2">{{ $t('blog.categories.productos', lang) }}</h2>
        <div class="g-post">
          <div class="g-post__items">
            <BlogPostThumb
              v-for="productPost in productPosts"
              :key="productPost.id"
              :post="productPost"
              class=""
            />
          </div>
          <div class="g-post__actions">
            <a :href="blogBasePath + '/categorias/productos'" class="button button--dark-outline"
              >{{ $t('blog.seeAllProducts', lang) }}</a
            >
          </div>
        </div>

        <div class="mar-t-3 mar-b-4">
          <div class="cta-lila">
            <h2 class="header-2 color-white">
              {{ $t('blog.ctaListaTitle', lang) }}
            </h2>
            <div class="mar-b-2">
              {{ $t('blog.ctaListaSubtitle', lang) }}
            </div>
            <a
              class="button button--primary"
              :alt="$t('blog.seeExampleListsCta1Alt', lang)"
              :href="blogBasePath + '/categorias/listas-de-ejemplo' + appQueryParam"
              >{{ $t('blog.seeExampleLists', lang) }}</a
            >
          </div>
        </div>

        <h2 class="header-2">{{ $t('blog.categories.maternidad', lang) }}</h2>
        <div class="g-post">
          <div class="g-post__items">
            <BlogPostThumb
              v-for="maternityPost in maternityPosts"
              :key="maternityPost.id"
              :post="maternityPost"
              class=""
            />
          </div>
          <div class="g-post__actions">
            <a
              :href="blogBasePath + '/categorias/maternidad' + appQueryParam"
              class="button button--dark-outline"
              >{{ $t('blog.seeAllMaternity', lang) }}</a
            >
          </div>
        </div>

        <div class="mar-t-3 mar-b-4">
          <div class="cta-bubles">
            <div class="cta-bubles__content">
              <h2 class="header-2">
                {{ $t('blog.ctaBublesTitleLine1', lang) }} <br />
                {{ $t('blog.ctaBublesTitleLine2', lang) }}
              </h2>
              <a
                class="button button--accent"
                :alt="$t('blog.seeExampleListsCta2Alt', lang)"
                :href="blogBasePath + '/categorias/listas-de-ejemplo' + appQueryParam"
                >{{ $t('blog.seeExampleLists', lang) }}</a
              >
            </div>
            <div class="cta-bubles__cover">
              <img
                src="../../assets/img/covers/cover-cta-icons.svg"
                alt=""
                loading="lazy"
              />
            </div>
          </div>
        </div>

        <h2 class="header-2">{{ $t('blog.categories.listasDeEjemplo', lang) }}</h2>
        <div class="g-post">
          <div class="g-post__items">
            <BlogPostThumb
              v-for="exampleListsPost in exampleListsPosts"
              :key="exampleListsPost.id"
              :post="exampleListsPost"
              class=""
            />
          </div>
          <div class="g-post__actions">
            <a
              :href="blogBasePath + '/categorias/listas-de-ejemplo' + appQueryParam"
              class="button button--dark-outline"
              >{{ $t('blog.seeAllExampleLists', lang) }}</a
            >
          </div>
          <!--          Sergi: Prova per tenir un directori de tots els articles i millorar SEO, hi hagui navegació per arribar a tots els articles -> Via categories és possible-->
          <!--          <div class="g-post__actions mt-4">-->
          <!--            <a-->
          <!--                href="/blog/posts"-->
          <!--                class="button button&#45;&#45;dark-outline"-->
          <!--            >Todos los artículos</a-->
          <!--            >-->
          <!--          </div>-->
        </div>
      </div>
    </main>
  </div>
</template>
<script>
import BlogPostThumb from "./components/BlogPostThumb.vue";
import { mapGetters } from "vuex";
import SubheaderBlog from "./SubheaderBlog.vue";

export default {
  name: "Blog",
  components: {
    BlogPostThumb,
    SubheaderBlog,
  },
  metaInfo() {
    return {
      title: this.$t('blog.metaTitle', this.lang),
      meta: [
        {
          name: "description",
          content: this.$t('blog.metaDescription', this.lang),
        },
      ],
      link: [{ rel: "canonical", href: "https://www.hellobb.net" + this.blogBasePath }],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "WebSite",
            publisher: {
              "@type": "Organization",
              name: this.$t('blog.orgName', this.lang),
              url: "https://www.hellobb.net" + this.blogBasePath,
              logo: {
                "@type": "ImageObject",
                url: "https://www.hellobb.net/logo-hellobb-dark.svg",
                width: 48,
                height: 48,
              },
            },
            url: "https://www.hellobb.net" + this.blogBasePath,
            image: {
              "@type": "ImageObject",
              url: "https://www.hellobb.net/hbb-card.jpg",
              width: 1200,
              height: 630,
            },
            mainEntityOfPage: {
              "@type": "WebPage",
              "@id": "https://www.hellobb.net" + this.blogBasePath,
            },
            description: this.$t('blog.jsonLdDescription', this.lang),
          },
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      featuredPost: "featuredPost",
      featured2Posts: "featured2Posts",
      productPosts: "productPosts",
      maternityPosts: "maternityPosts",
      exampleListsPosts: "exampleListsPosts",
      blogBasePath: "blogBasePath",
    }),
    appQueryParam() {
      if (this.$store.state.cookies.sourceApp == "true") return "?source=app";
      return "";
    },
    lang() {
      return this.$route.meta?.lang || this.$i18n.locale;
    },
  },
  async serverPrefetch() {
    await this.$store.dispatch("getFeaturedPost");
    await this.$store.dispatch("getFeatured2Posts");
    await this.$store.dispatch("getProductPosts");
    await this.$store.dispatch("getMaternityPosts");
    await this.$store.dispatch("getExampleListsPosts");
  },
};
</script>
<style lang=""></style>
